import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import DataOtherDataFleetModal from '../../../../components/management/fleets/auxModals/DataOtherDataFleetModal'
import { closeDataOtherDataFleetModal } from '../../../../actions/management/auxModals/auxModals'
import { fetchOperateDataFleetModalsPermissions, getOtherDataFleet } from '../../../../actions/management/management'
import { setOperateDataOtherDataFleetProcess } from '../../../../actions/unattendedProcess/unattendedProcess'
import { saleCodes } from '../../../../constants/dossier/common/fieldCodePermissions'
import { setActiveSection } from '../../../../actions/dossier/common/buttonsSidebar'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.managementAuxModals.dataOtherDataFleetModal,
    componentConfiguration: state.management.operateFleetModal.componentsModalConfiguration
      ? state.management.operateFleetModal.componentsModalConfiguration.componentsConfiguration.find((x) => x.code === saleCodes.other_data)
      : null,
    combos: {
      ...state.combos
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(
      {
        closeDataOtherDataFleetModal,
        fetchOperateDataFleetModalsPermissions,
        setOperateDataOtherDataFleetProcess,
        setActiveSection,
        getOtherDataFleet
      },
      dispatch
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(TrackingContainer(DataOtherDataFleetModal, true)))
